module.exports = __webpack_public_path__ + "img/metamask-fox.c06f3a3e.svg";